<template>
  <div class="workflow-illustration">
    <!-- Option 2: HTML/CSS Illustration -->
    <div v-if="type === 'html'" class="html-illustration">
      <div class="illustration-container">
        <!-- Trigger Node -->
        <div class="preview-node trigger-node">
          <div class="node-icon trigger-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
              <path d="M9 16l2 2 4-4"></path>
            </svg>
          </div>
          <div class="node-content">
            <span class="node-label">Appointment Scheduled</span>
            <span class="node-type">Trigger</span>
          </div>
        </div>

        <!-- Connection Line 1 -->
        <div class="connection-line"></div>

        <!-- Action Node 1 -->
        <div class="preview-node action-node">
          <div class="node-icon action-icon sms-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
            </svg>
          </div>
          <div class="node-content">
            <span class="node-label">Send Reminder SMS</span>
            <span class="node-type">Action</span>
          </div>
        </div>

        <!-- Connection Line 2 -->
        <div class="connection-line"></div>

        <!-- Action Node 2 -->
        <div class="preview-node action-node">
          <div class="node-icon action-icon task-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 11l3 3L22 4"></path>
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
            </svg>
          </div>
          <div class="node-content">
            <span class="node-label">Create Follow-up Task</span>
            <span class="node-type">Action</span>
          </div>
        </div>
      </div>

      <!-- Decorative elements -->
      <div class="decoration decoration-1"></div>
      <div class="decoration decoration-2"></div>
      <div class="decoration decoration-3"></div>
    </div>

    <!-- Option 3: SVG Illustration -->
    <div v-else-if="type === 'svg'" class="svg-illustration">
      <svg viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg" class="workflow-svg">
        <!-- Background decorations -->
        <defs>
          <linearGradient id="triggerGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color:#e0f2fe;stop-opacity:1" />
            <stop offset="100%" style="stop-color:#bae6fd;stop-opacity:1" />
          </linearGradient>
          <linearGradient id="actionGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
            <stop offset="100%" style="stop-color:#f8fafc;stop-opacity:1" />
          </linearGradient>
          <linearGradient id="lineGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style="stop-color:#3abf94;stop-opacity:1" />
            <stop offset="100%" style="stop-color:#a5b4fc;stop-opacity:1" />
          </linearGradient>
          <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="2" stdDeviation="3" flood-opacity="0.1"/>
          </filter>
        </defs>

        <!-- Decorative circles -->
        <circle cx="50" cy="50" r="30" fill="#f0fdf4" opacity="0.5"/>
        <circle cx="350" cy="250" r="40" fill="#e0f2fe" opacity="0.5"/>
        <circle cx="380" cy="80" r="20" fill="#fef3c7" opacity="0.5"/>

        <!-- Connection lines -->
        <path d="M 200 85 L 200 115" stroke="url(#lineGrad)" stroke-width="2" stroke-dasharray="4,4" fill="none">
          <animate attributeName="stroke-dashoffset" values="8;0" dur="1s" repeatCount="indefinite"/>
        </path>
        <path d="M 200 175 L 200 205" stroke="url(#lineGrad)" stroke-width="2" stroke-dasharray="4,4" fill="none">
          <animate attributeName="stroke-dashoffset" values="8;0" dur="1s" repeatCount="indefinite"/>
        </path>

        <!-- Trigger Node -->
        <g filter="url(#shadow)" class="node-group">
          <rect x="100" y="30" width="200" height="55" rx="10" fill="url(#triggerGrad)" stroke="#93c5fd" stroke-width="1"/>
          <!-- Calendar icon -->
          <rect x="115" y="45" width="24" height="24" rx="4" fill="#3b82f6" opacity="0.2"/>
          <path d="M 120 52 L 134 52 M 124 48 L 124 51 M 130 48 L 130 51" stroke="#3b82f6" stroke-width="1.5" fill="none"/>
          <rect x="118" y="55" width="18" height="12" rx="2" fill="none" stroke="#3b82f6" stroke-width="1.5"/>
          <!-- Text -->
          <text x="150" y="55" font-family="Inter, sans-serif" font-size="12" font-weight="600" fill="#1e40af">Appointment Scheduled</text>
          <text x="150" y="70" font-family="Inter, sans-serif" font-size="10" fill="#64748b">Trigger</text>
        </g>

        <!-- Action Node 1 -->
        <g filter="url(#shadow)" class="node-group">
          <rect x="100" y="120" width="200" height="55" rx="10" fill="url(#actionGrad)" stroke="#e2e8f0" stroke-width="1"/>
          <!-- SMS icon -->
          <rect x="115" y="135" width="24" height="24" rx="4" fill="#10b981" opacity="0.2"/>
          <path d="M 120 147 Q 127 155 134 147 L 134 142 Q 127 138 120 142 Z" fill="none" stroke="#10b981" stroke-width="1.5"/>
          <!-- Text -->
          <text x="150" y="145" font-family="Inter, sans-serif" font-size="12" font-weight="600" fill="#334155">Send Reminder SMS</text>
          <text x="150" y="160" font-family="Inter, sans-serif" font-size="10" fill="#64748b">Action</text>
        </g>

        <!-- Action Node 2 -->
        <g filter="url(#shadow)" class="node-group">
          <rect x="100" y="210" width="200" height="55" rx="10" fill="url(#actionGrad)" stroke="#e2e8f0" stroke-width="1"/>
          <!-- Task icon -->
          <rect x="115" y="225" width="24" height="24" rx="4" fill="#8b5cf6" opacity="0.2"/>
          <path d="M 120 237 L 124 241 L 134 231" fill="none" stroke="#8b5cf6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <!-- Text -->
          <text x="150" y="235" font-family="Inter, sans-serif" font-size="12" font-weight="600" fill="#334155">Create Follow-up Task</text>
          <text x="150" y="250" font-family="Inter, sans-serif" font-size="10" fill="#64748b">Action</text>
        </g>

        <!-- Animated pulse on trigger -->
        <circle cx="200" cy="57" r="5" fill="#3abf94" opacity="0">
          <animate attributeName="r" values="5;15;5" dur="2s" repeatCount="indefinite"/>
          <animate attributeName="opacity" values="0.6;0;0.6" dur="2s" repeatCount="indefinite"/>
        </circle>
      </svg>
    </div>

    <!-- Caption -->
    <div class="illustration-caption" v-if="showCaption">
      <h3>{{ title || 'Automate Your Workflows' }}</h3>
      <p>{{ description || 'Connect triggers and actions to automate patient communications, tasks, and more.' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowPreviewIllustration',
  props: {
    type: {
      type: String,
      default: 'html', // 'html' or 'svg'
      validator: (value) => ['html', 'svg'].includes(value)
    },
    showCaption: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.workflow-illustration {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
}

/* HTML/CSS Illustration Styles */
.html-illustration {
  position: relative;
  padding: 32px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  overflow: hidden;
}

.illustration-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  position: relative;
  z-index: 1;
}

.preview-node {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-radius: 12px;
  min-width: 220px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.preview-node:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.trigger-node {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  border: 1px solid #93c5fd;
}

.action-node {
  background: white;
  border: 1px solid #e2e8f0;
}

.node-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.trigger-icon {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.sms-icon {
  background: rgba(16, 185, 129, 0.15);
  color: #10b981;
}

.task-icon {
  background: rgba(139, 92, 246, 0.15);
  color: #8b5cf6;
}

.node-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.node-label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}

.trigger-node .node-label {
  color: #1e40af;
}

.node-type {
  font-size: 11px;
  color: #64748b;
}

.connection-line {
  width: 2px;
  height: 24px;
  background: linear-gradient(to bottom, #3abf94, #a5b4fc);
  position: relative;
}

.connection-line::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  background: #3abf94;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 0.4; transform: translateX(-50%) scale(1); }
  50% { opacity: 1; transform: translateX(-50%) scale(1.2); }
}

/* Decorative elements */
.decoration {
  position: absolute;
  border-radius: 50%;
  opacity: 0.5;
}

.decoration-1 {
  width: 60px;
  height: 60px;
  background: #f0fdf4;
  top: -20px;
  left: -20px;
}

.decoration-2 {
  width: 80px;
  height: 80px;
  background: #e0f2fe;
  bottom: -30px;
  right: -30px;
}

.decoration-3 {
  width: 40px;
  height: 40px;
  background: #fef3c7;
  top: 20px;
  right: -10px;
}

/* SVG Illustration Styles */
.svg-illustration {
  width: 100%;
  max-width: 400px;
}

.workflow-svg {
  width: 100%;
  height: auto;
}

.node-group {
  transition: transform 0.2s ease;
}

.node-group:hover {
  transform: translateY(-2px);
}

/* Caption Styles */
.illustration-caption {
  text-align: center;
  margin-top: 24px;
  max-width: 320px;
}

.illustration-caption h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.illustration-caption p {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

/* Responsive */
@media (max-width: 480px) {
  .preview-node {
    min-width: 180px;
    padding: 10px 14px;
  }

  .node-label {
    font-size: 12px;
  }

  .node-icon {
    width: 30px;
    height: 30px;
  }

  .svg-illustration {
    max-width: 300px;
  }
}
</style>
